export default "__VITE_ASSET__5dec278a__"